import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVuejs, faDocker, faPython, faJava, faLinux } from '@fortawesome/free-brands-svg-icons';
import Chip from '@mui/material/Chip';
import OllamaIcon from './OllamaIcon';
import '../assets/styles/Expertise.scss';

const labelsFirst = [
    "VueJS",
    "JavaScript",
    "HTML",
    "CSS",
    "Java",
    "J2EE",
    "Python",
    "Django",
    "SQL",
    "PostgreSQL",
    "Postman"
];

const labelsSecond = [
    "Git",
    "GitLab",
    "Docker",
    "DigitalOcean",
    "Azure",
    "Linux",
    "WildFly",
];

const labelsThird = [
    "OpenAI",
    "LangChain",
    "Ollama",
    "Hugging Face",
    "Streamlit",
    "Azure AI",
    "Cursor"
];

function Expertise() {
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>Expertise</h1>
            <div className="skills-grid">
                <div className="skill">
                    <div className="skill-icons">
                        <FontAwesomeIcon icon={faJava} size="3x"/>
                        <FontAwesomeIcon icon={faVuejs} size="3x"/>
                    </div>
                    <h3>Full Stack Web Development</h3>
                    <p>I have built a diverse array of web applications from scratch using modern technologies such as Vue/React, Java and Django. I have a strong proficiency in the SDLC process and frontend + backend development.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsFirst.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <div className="skill-icons">
                        <FontAwesomeIcon icon={faDocker} size="3x"/>
                        <FontAwesomeIcon icon={faLinux} size="3x"/>
                    </div>
                    <h3>DevOps & MLOps</h3>
                    <p>Once the application is built, I help clients set up DevOps testing, CI/CD pipelines, and deployment automation to support the successful Go-Live.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsSecond.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <div className="skill-icons">
                        <FontAwesomeIcon icon={faPython} size="3x"/>
                        <OllamaIcon/>
                    </div>
                    <h3>GenAI & LLM</h3>
                    <p>Stay relevant in the market by leveraging the latest AI models in your projects. I have experience building GenAI-enabled solutions to empower intelligent decision making.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsThird.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Expertise;